module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clientpicker-wrap"
  }, [_c('label', {
    staticClass: "label input__label"
  }, [_vm._v(_vm._s(_vm._translate('clientSelector.search')))]), _vm._v(" "), _c('div', {
    staticClass: "clientpicker-input"
  }, [_c('input', {
    staticClass: "input",
    attrs: {
      "id": _vm.id + '-search',
      "type": "search"
    },
    on: {
      "keyup": _vm.checkInput
    }
  }), _vm._v(" "), (_vm.getClientData()) ? _c('ul', {
    staticClass: "clientpicker-list"
  }, _vm._l((_vm.getClientData()), function(field, findex) {
    return _c('li', [_c('input', {
      staticClass: "clientpicker-list__input",
      attrs: {
        "name": _vm.id + '[]',
        "id": _vm.setItemId(findex),
        "type": "radio"
      },
      domProps: {
        "value": findex
      },
      on: {
        "change": _vm.selectClientId
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "clientpicker-list__label",
      attrs: {
        "for": _vm.setItemId(findex)
      },
      domProps: {
        "innerHTML": _vm._s(_vm.outputName(field, true))
      }
    })])
  })) : _vm._e()]), _vm._v(" "), (this.$data.showClients) ? _c('div', {
    staticClass: "clients"
  }, [_c('h2', {
    staticClass: "clients__heading"
  }, [_vm._v(_vm._s(_vm._translate('clientSelector.activeClients')))]), _vm._v(" "), _c('ul', {
    staticClass: "full-client-list"
  }, _vm._l((_vm.getClientList()), function(field, findex) {
    return _c('li', {
      staticClass: "full-client-list__item"
    }, [_c('input', {
      staticClass: "full-client-list__input",
      attrs: {
        "name": _vm.id + '[]',
        "id": _vm.setItemId(findex),
        "type": "radio"
      },
      domProps: {
        "value": _vm.outputId(field)
      },
      on: {
        "change": _vm.selectClientId
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "full-client-list__label",
      attrs: {
        "for": _vm.setItemId(findex)
      },
      domProps: {
        "innerHTML": _vm._s(_vm.outputName(field, false))
      }
    }, [_vm._v(_vm._s(_vm._translate('clientSelector.clientBase')))])])
  })), _vm._v(" "), _c('h2', {
    staticClass: "clients__heading clients__heading--inactive"
  }, [_vm._v(_vm._s(_vm._translate('clientSelector.inactiveClients')))]), _vm._v(" "), _c('ul', {
    staticClass: "full-client-list"
  }, _vm._l((_vm.getClientList(true)), function(field, findex) {
    return _c('li', {
      staticClass: "full-client-list__item deactive"
    }, [_c('input', {
      staticClass: "full-client-list__input",
      attrs: {
        "name": _vm.id + 'Inactive[]',
        "id": _vm.setItemId(_vm.outputId(field)),
        "type": "radio"
      },
      domProps: {
        "value": _vm.outputId(field)
      },
      on: {
        "change": _vm.selectClientId
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "full-client-list__label",
      attrs: {
        "for": _vm.setItemId(_vm.outputId(field))
      },
      domProps: {
        "innerHTML": _vm._s(_vm.outputName(field, false))
      }
    }, [_vm._v(_vm._s(_vm._translate('clientSelector.clientBase')))])])
  }))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel__control"
  }, [_c('div', {
    staticClass: "panel__buttons"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": _vm.toggleClients
    }
  }, [_vm._v(_vm._s(_vm.setAllClientsButton()))]), _vm._v(" "), (_vm.$data.showClients) ? _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.printClients
    }
  }, [_vm._v("Print Client List")]) : _vm._e(), _vm._v(" "), (_vm.$data.showClients) ? _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.exportClients
    }
  }, [_vm._v("Export Client List")]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-14fa7af5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ClientPicker.vue
// module id = 312
// module chunks = 0